import { aluminaGlobal } from '../aluminaGlobal';
import { mount, patch } from './vdom';
export { jsx, Fragment } from './jsx';
export function render(vnode, rootDom) {
    const prevVDom = aluminaGlobal.prevRootVdom;
    if (!prevVDom) {
        mount(rootDom, vnode);
    }
    else {
        patch(rootDom, vnode, prevVDom);
    }
    aluminaGlobal.prevRootVdom = vnode;
}
//# sourceMappingURL=index.js.map